import { queryLikeConfig, addLikeConfig, updateLikeConfig, deleteLikeConfig } from "@/views/zhiji/js/services/service.js";

export default {
    state: {
        likeConfList: [],
    },
    mutations: {
        updateLikeConfData(state, tableData) {
            state.likeConfList = tableData;
        },
    },
    actions: {
        queryLikeConfList(context, params) {
            queryLikeConfig(params).then(function(tableData) {
                context.commit("updateLikeConfData", tableData);
            })
        },
        deleteLikeConf(context, param) {
            deleteLikeConfig(param).then(function() {
                context.dispatch("queryLikeConfList");
            });
        },
        addLikeConf(context, params) {
            addLikeConfig(params).then(function() {
                context.dispatch("queryLikeConfList");
            })
        },
        updateLikeConf(context, params) {
            updateLikeConfig(params).then(function() {
                context.dispatch("queryLikeConfList");
            })
        },
    }
}
